import React from "react";
import { Box, Typography } from "@mui/material";
import { leadDataStyles } from "../../../assets/MUIStyles/leadDataStyle";
import { ReactComponent as ExportIcon } from "../../../assets/icons/export.svg";
import BaseButton from "../Common/Buttons/BaseButton";
import DynamicTable from "../CommonComponents/Table/DynamicTable";

const CommonCallsData = ({ heading, exportFn, data }) => {
  return (
    <Box className="my-4" sx={leadDataStyles.tableContainer}>
      <Box className="flex-between mb-1">
        <Typography className="font-14-grey">{heading}</Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <BaseButton
            title="Export"
            variant="outlined"
            startIcon={<ExportIcon height={14} width={14} />}
            handleClick={exportFn}
            styles={{ px: 2, fontSize: 12 }}
          />
        </Box>
      </Box>

      <Box className="my-2">
        <DynamicTable
          columns={[
            {
              label: "Account Email",
              field: "user_email",
              styles: { textTransform: "none", py: 1.5 },
            },
            {
              label: "Account Name",
              field: "account_name",
            },
            {
              label: "Total Dialed",
              render: ({ account_data }) => account_data?.dialed,
            },
            {
              label: "Total Connected",
              render: ({ account_data }) => account_data?.connected,
            },
            {
              label: "Total Errors",
              render: ({ account_data }) => account_data?.error,
            },
            {
              label: "Misc",
              render: ({ account_data }) => account_data?.misc,
            },
            {
              label: "Total Voicemail",
              render: ({ account_data }) => account_data?.voicemail,
            },
            {
              label: "Duration",
              render: ({ account_data }) => account_data?.duration,
            },
            {
              label: "Pricing",
              render: ({ account_data }) => account_data?.price,
            },
            {
              label: "Whitelabel",
              field: "white_label_super_admin",
            },
            {
              label: "Pickup Rate",
              render: ({ sid_data }) => sid_data?.pikup_rate,
            },
            {
              label: "Average Call Duration",
              render: ({ sid_data }) => sid_data?.average_call_duration,
            },
          ]}
          data={data}
          rowCount={data?.length}
          noDataAvailableMessage={`No ${heading} Found`}
        />
      </Box>
    </Box>
  );
};

export default CommonCallsData;
